export default "__VITE_ASSET__CrlB3_nA__"